var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcShuffle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 18H5.32408C6.99585 18 8.557 17.1645 9.48433 15.7735L14.5157 8.2265C15.443 6.8355 17.0042 6 18.6759 6H19H19.7663M5 6H5.32408C6.99585 6 8.557 6.8355 9.48433 8.2265L12 12L14.5157 15.7735C15.443 17.1645 17.0042 18 18.6759 18H19H19.7663M18.25 4L19.4757 5.2257C19.6892 5.43922 19.7849 5.72323 19.7663 6M18 7.875L19.4088 6.70102C19.6285 6.51789 19.7487 6.26219 19.7663 6M18.25 16L19.4757 17.2257C19.6892 17.4392 19.7849 17.7232 19.7663 18M18 19.875L19.4088 18.701C19.6285 18.5179 19.7487 18.2622 19.7663 18",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShuffle);
export default __webpack_public_path__ + "static/media/ic_shuffle.4d1f6f8d236f78a5438e4ce226509248.svg";
export { ForwardRef as ReactComponent };